import { PlusIcon } from "@gadgetinc/themes/src/icons/PlusIcon";
import { expandBaseWebBorder, paddingUtil } from "@gadgetinc/themes/src/utils";
import { useStyletron } from "baseui";
import React, { forwardRef } from "react";
import type { ButtonProps } from "../../editor/Button";
import { EntryButton } from "./EntryButton";

export const PlusButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const [_css, $theme] = useStyletron();
  return (
    <EntryButton
      ref={ref}
      {...props}
      overrides={{
        BaseButton: {
          style: {
            ...expandBaseWebBorder({
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: $theme.colors.primary300,
            }),
            ...paddingUtil("3px"),
            backgroundColor: $theme.colors.white,
            ":focus-visible": {
              backgroundColor: $theme.colors.white,
            },
            ":hover": {
              border: `solid 1px ${$theme.colors.primary400}`,
            },
            boxShadow: $theme.lighting.depth2,
          },
        },
      }}
    >
      <PlusIcon />
    </EntryButton>
  );
});
